import { EMPTY_LIST } from '../../../../constants/common'
import { TableUserListCell } from '../../../Table'
import {
  toUserMultiValueWithArchive,
  UserMultiValueContentLinked,
  UserMultiValueListMoreItemLinked,
} from '../../../User'

function EmailTableRowUserMultiValuedListCell({
  items = EMPTY_LIST,
  ...restProps
}) {
  return (
    <TableUserListCell
      {...restProps}
      Content={UserMultiValueContentLinked}
      listProps={{
        MoreItem: UserMultiValueListMoreItemLinked,
        itemProps: { Content: UserMultiValueContentLinked },
      }}
      value={items.map(toUserMultiValueWithArchive)}
    />
  )
}

export default EmailTableRowUserMultiValuedListCell
